import React from 'react';
import { Space, Title, Text, Checkbox } from 'components';
import { INotificationSettings, IInstantNotificationSettings } from '@bb/users';
import { ListingLabelContext } from 'contexts';

type InstantUpdatesProps = {
  instantNotifications: IInstantNotificationSettings;
  setModifiedNotifications: React.Dispatch<
    React.SetStateAction<INotificationSettings>
  >;
  prefixComponent: React.ReactElement;
};

const InstantUpdates: React.FC<InstantUpdatesProps> = ({
  instantNotifications,
  prefixComponent,
  setModifiedNotifications,
}) => {
  const { getLabel, isHidden } = React.useContext(ListingLabelContext);

  let fieldsMap: [
    keyof IInstantNotificationSettings,
    {
      key: string;
      prefix: string;
      shouldHide?: boolean;
      defaultLabel?: string;
    },
  ][] = [
    [
      'pricechange',
      {
        key: 'PRICE_CHANGE',
        prefix: getLabel('MLS') || '',
        shouldHide: isHidden('MLS'),
      },
    ],
    ['assignment', { key: 'ASSIGNMENT', prefix: '' }],
    ['comingSoon', { key: 'COMING_SOON', prefix: '' }],
    [
      'newConstruction',
      { key: 'NEW_CONSTRUCTION', prefix: '', defaultLabel: 'Constructions' },
    ],
    ['mls', { key: 'MLS', prefix: '' }],
  ];

  fieldsMap = fieldsMap.filter(
    ({ 1: { key, shouldHide } }) => !shouldHide && !isHidden(key),
  );

  if (!fieldsMap.length) return null;

  return (
    <>
      {prefixComponent}
      <Space direction="vertical" size="large">
        <Space direction="vertical">
          <Title level={3}>Instant Updates</Title>

          <Text>
            You can choose to be notified instantly when a new listing of any of
            the below types is created:
          </Text>
        </Space>
        <Space direction="vertical">
          {fieldsMap.map(([field, { key, prefix, defaultLabel }]) => (
            <Checkbox
              key={key}
              data-cy={`instant-updates-${key}`}
              checked={instantNotifications[field]}
              onChange={({ target: { checked } }) =>
                setModifiedNotifications(prev => ({
                  ...prev,
                  instant: {
                    ...prev.instant,
                    [field]: checked,
                  },
                }))
              }
            >
              {prefix} {getLabel(key, defaultLabel)}
            </Checkbox>
          ))}
        </Space>
      </Space>
    </>
  );
};

export default InstantUpdates;
